<template>
  <div class="problem-solving flex-box">
    <div class="title">{{ title }}</div>
    <div class="description">{{ description }}</div>
    <div class="content-bj">
      <img v-lazy="jjwt2" alt="">
    </div>
    <div class="problem-content flex-box">
      <div class="content-left-wrap">
        <div 
          class="content-left"
          ref="chartBox"
          @click="onChartTap"
          @mouseenter="clearIntervalHandle()"
          @mouseleave="setIntervalHandle()"
        >
          <img v-if="isPercentage" v-lazy="img" alt="" width="100%" height="100%">
          <img v-else v-lazy="img1" alt="" width="100%" height="100%">
          <div 
            v-for="(item, k) in problemList" 
            :key="k" 
            class="left-item" 
            :class="`${ k === activeInd ? `left-item${k+1} is-active` : `left-item${k+1}`}`"
            @click.stop="mouseoverHandle(item, k)"
            @mouseenter="mouseoverHandle(item, k)"
          >
            <img v-lazy="item.img" alt="">
            <div class="item-name">{{ item.name }}</div>
            <div class="sanjiao"></div>
          </div>
        </div>
      </div>
      <div class="content-right">
        <div class="percentage" v-if="isPercentage">{{problemInfo.percentage}}%</div>
        <div class="right-name">{{problemInfo.name}}</div>
        <div class="henggang"></div>
        <div class="descs">
          <div v-for="(item, k) in  problemInfo.list" :key="k">{{ item }}</div>
        </div>
      </div>
    </div>
   
  </div>
</template>
<script>
import jjwt1 from '@/assets/images/jjwt1.png'
import jjwt1_1 from '@/assets/images/jjwt1-1.jpg'
import jjwt2 from '@/assets/images/jjwt2.png'

import yh1 from '@/assets/images/yh3-1.png'
import yh2 from '@/assets/images/yh3-2.png'
import yh3 from '@/assets/images/yh3-3.png'
import yh4 from '@/assets/images/yh3-4.png'
import yh5 from '@/assets/images/yh3-5.png'
import yh6 from '@/assets/images/yh3-6.png'
import yh7 from '@/assets/images/yh3-7.png'


export default {
  props: {
    isPercentage: {
      type: Boolean,
      default: true
    },
    title: {
      type: String,
      default: '璞华易研PLM能解决哪些问题？'
    },
    description: {
      type: String,
      default: '璞华易研PLM可以有效解决产品研发管理中的核心痛点，包括数据管控和安全、任务执行、项目监督以及标准化流程管理等方面的问题'
    },
    textList: {
      type: Array,
      default: () => {
        return []
      }
    }
  },
  data() {
    return {
      timer: null,
      img: jjwt1,
      img1: jjwt1_1,
      jjwt2,
      activeInd: 0,
    }
  },
  computed: {
    problemInfo({problemList, activeInd}) {
      return problemList[activeInd] || {}
    },
    problemList({ textList }) {
      return [
        {
          name: (textList[0] || {}).name || '数据管控与安全',
          percentage: '25',
          img: yh1,
          list: (textList[0] || {}).list || [
            '难以保证数据的合法性、准确性 、唯一性',
            '难以体现数据之间的关联性',
            '难以体现数据之间的借用关系',
            '难以管控BOM的准确性',
            '难以对文档进行缜密的权限控制',
            '难以防范病毒及系统问题引起的数据丢失'
          ],
        },
        {
          name: (textList[1] || {}).name || '任务执行',
          percentage: '20',
          img: yh2,
          list: (textList[1] || {}).list || [
            '任务指令容易出错',
            '任务执行难以实时监督',
            '难以控制任务的成果',
            '人员的绩效考核难以执行',
            '技术人员之间沟通不畅'
          ],
        },
        {
          name: (textList[2] || {}).name || '标准化管理',
          percentage: '15',
          img: yh3,
          list: (textList[2] || {}).list || [
            '文档内容及格式混乱',
            '物料的编码混乱，经常编码和物料不对版',
            '产品的采标率太低',
            '项目模板太多，查看繁琐',
            '变更内容无法及时同步，无法追溯'
          ],
        },
        {
          name: (textList[3] || {}).name || '项目监督',
          percentage: '15',
          img: yh4,
          list: (textList[3] || {}).list || [
            '难以按照标准对产品研发生命周期进行有效控制',
            '难以实时监控项目实际进度',
            '难以控制项目的过程',
            'ISO执行与工作效率矛盾问题',
            '项目的绩效考核出现问题'
          ],
        },
        {
          name: (textList[4] || {}).name || '流程管理',
          percentage: '10',
          img: yh5,
          list: (textList[4] || {}).list || [
            '文档数据没有管理规范',
            '难以实现产品信息标准化',
            '没有建立标准的研发过程及数据审核过程',
            '审批人员不在无法及时转签',
            '物料BOM检索复杂'
          ],
        },
        {
          name: (textList[5] || {}).name || '其他',
          percentage: '10',
          img: yh6,
          list: (textList[5] || {}).list || [
            '文件发布与共享体制混乱',
            '技术工程缺少协同工作平台',
            '信息传达困难，无法形成记录和提醒'
          ],
        },
        {
          name: (textList[6] || {}).name || '系统集成',
          percentage: '5',
          img: yh7,
          list: (textList[6] || {}).list || [
            '不同格式的数据无法共享',
            '设计软件不能为后期BOM提供数据',
            '信息孤岛，各系统数据无法互通',
            '图纸调用内容出错'
          ],
        }
      ]
    }
  },
  beforeDestroy() {
    this.clearIntervalHandle()
  },
  created() {
  },
  mounted() {
    this.setIntervalHandle()
  },
  methods: {
    clearIntervalHandle() {
      clearInterval(this.timer)
    },
    setIntervalHandle() {
      this.timer = setInterval(() => {
        const len = this.problemList.length
        this.activeInd ++
        if(len === this.activeInd) this.activeInd = 0
      }, 5000)
    },
    mouseoverHandle(item, k) {
      this.activeInd = k
    },
    onChartTap(e) {
      const el = this.$refs.chartBox
      if (!el) return
      const box = el.getBoundingClientRect()
      const x = e.clientX - box.left
      const y = e.clientY - box.top
      const dx = x - box.width / 2
      const dy = y - box.height / 2
      const dist = Math.sqrt(dx * dx + dy * dy)
      const r = Math.min(box.width, box.height) / 2
      if (dist < r * 0.28 || dist > r * 0.98) return
      let deg = Math.atan2(dx, -dy) * 180 / Math.PI
      if (deg < 0) deg += 360
      const slices = [
        { size: 5, index: 6 },
        { size: 25, index: 0 },
        { size: 20, index: 1 },
        { size: 15, index: 2 },
        { size: 15, index: 3 },
        { size: 10, index: 4 },
        { size: 10, index: 5 }
      ]
      let acc = 0
      for (let i = 0; i < slices.length; i += 1) {
        acc += slices[i].size * 3.6
        if (deg < acc) {
          this.activeInd = slices[i].index
          return
        }
      }
    }
  }
}
</script>

<style lang="scss" scoped>
$img: "../../assets/images";

.problem-solving {
  padding: 10rem 0rem 15.5rem 0;
  flex-direction: column;
  align-items: center;
  background: linear-gradient( 153deg, #F4F7FF 0%, #FFFFFF 100%);
  position: relative;
  .content-bj {
    position: absolute;
    width: 113.6rem;
    height: 74.6rem;
    right: 0;
    bottom: 0;
    img {
      width: 100%;
      height: 100%;
      z-index: -1;
    }
  }

  .title {
    font-size: 4rem;
    font-weight: 600;
    color: #333333;
    line-height: 4rem;
    margin-bottom: 2.4rem;
  }

  .description {
    font-size: 1.8rem;
    font-weight: 400;
    color: #666A77;
    line-height: 1.8rem;
    margin-bottom: 10.2rem;
  }

  .content-left-wrap {
    display: contents;
  }

  .problem-content {
    width: 100%;
    z-index: 9;
    .content-left {
      width: 56rem;
      height: 56.1rem;
      margin-left: 33.4rem;
      position: relative;

      .left-item {
        position: absolute;
        text-align: center;
        width: 13rem;
        img {
          width: 4.8rem;
          height: 4.8rem;
        }
        .item-name {
          height: 2rem;
          font-family: PingFangSC, PingFang SC;
          font-weight: 500;
          font-size: 1.8rem;
          color: #FFFFFF;
          line-height: 1.95rem;
          text-align: center;
          font-style: normal;
        } 
      }

      .sanjiao {
        position: absolute;
        border: 1.5rem solid;
        width: 0;
        height: 0;
        border-color: transparent;
        display: none;
      }

      .left-item1 {
        top: 7.2rem;
        right: 8.2rem;
        &.is-active {
          .sanjiao {
            display: inline-block;
            border-color: #2372ff transparent transparent transparent;
            transform: rotate(37deg);
            top: 8.6rem;
            left: -.2rem;
          }
        }
      }
      .left-item2 {
        top: 32rem;
        right: 1.5rem;
        &.is-active {
          .sanjiao {
            display: inline-block;
            border-color: transparent #33b2e4 transparent transparent;
            transform: rotate(20deg);
            top: -1rem;
            left: -2.3rem;
          }
        }
      }
      .left-item3 {
        bottom: 4rem;
        right: 18.5rem;
        &.is-active {
          .sanjiao {
            display: inline-block;
            border-color: transparent transparent #64d1da transparent;
            transform: rotate(-7deg);
            top: -5.2rem;
            left: 4rem;
          }
        }
      }
      .left-item4 {
        bottom: 9.5rem;
        left: 7rem;
        &.is-active {
          .sanjiao {
            display: inline-block;
            border-color: transparent transparent transparent #61dda9;
            transform: rotate(-48deg);
            top: -3rem;
            left: 10.5rem;
          }
        }
      }
      .left-item5 {
        top: 24rem;
        left: 0rem;
        &.is-active {
          .sanjiao {
            display: inline-block;
            border-color: transparent transparent transparent #7399fc;
            transform: rotate(-3deg);
            top: 3rem;
            left: 13rem;
          }
        }
      }
      .left-item6 {
        top: 11.5rem;
        left: 4.5rem;
        &.is-active {
          .sanjiao {
            display: inline-block;
            border-color: transparent transparent transparent #33b2e4;
            transform: rotate(40deg);
            top: 6.5rem;
            left: 11.5rem;
            
          }
        }
      }
      .left-item7 {
        top: 3.5rem;
        left: 16rem;
        &.is-active {
          .sanjiao {
            display: inline-block;
            border-color: #64d1da transparent transparent transparent;
            transform: rotate(-16deg);
            top: 10rem;
            left: 7rem;
          }
        }
      }
    }
    .content-right {
      width: 56rem;
      height: 56.1rem;
      margin-left: 17.7rem;
      .percentage {
        margin-top: 2.3rem;
        height: 8.4rem;
        font-family: DINAlternate, DINAlternate;
        font-weight: bold;
        font-size: 7.2rem;
        color: #2372FF;
        line-height: 8.4rem;
        font-style: normal;
      }
      .right-name {
        margin-top: 1.7rem;
        height: 4.8rem;
        font-family: PingFangSC, PingFang SC;
        font-weight: 500;
        font-size: 4.8rem;
        color: #333333;
        line-height: 4.8rem;
        text-align: left;
        font-style: normal;
      }
      .henggang {
        width: 7rem;
        height: 0.6rem;
        background: #2372FF;
        border-radius: 0.3rem;
        margin: 3.3rem 0 5.4rem;
      }
      .descs {
        div {
          font-family: PingFangSC, PingFang SC;
          font-weight: 400;
          font-size: 2.2rem;
          color: #333333;
          line-height: 4.4rem;
          text-align: left;
          font-style: normal;
          position: relative;
          padding-left: 3rem;
          &::before {
            position: absolute;
            left: 0;
            top: 1.5rem;
            content: "";
            width: 1rem;
            height: 1rem;
            border: 0.2rem solid #3674FE;
            display: inline-block;
            border-radius: 50%;
            margin-right: 1.2rem;
          }
        }
      }
    }
    
  }
}

@import "@/styles/mixins.scss";

@include mobile {
  .problem-solving {
    padding: 4.8rem 1.6rem 6.4rem;
    .content-bj {
      display: none;
    }
    .title {
      font-size: 2.4rem;
      line-height: 3.2rem;
      text-align: center;
    }
    .description {
      font-size: 1.4rem;
      line-height: 2.2rem;
      margin-bottom: 2.4rem;
      text-align: center;
    }
    .content-left-wrap {
      display: block;
      width: 100%;
      max-width: 34rem;
      margin: 0 auto 2.4rem;
    }
    .problem-content {
      flex-wrap: wrap;
      .content-left {
        display: block;
        width: 100%;
        height: auto;
        aspect-ratio: 1 / 1;
        margin: 0;
        position: relative;
        transform: none;
        > img {
          position: absolute;
          top: 0;
          left: 0;
          width: 100%;
          height: 100%;
          object-fit: contain;
          pointer-events: none;
        }
        .left-item {
          z-index: 2;
          width: 28%;
          overflow: visible;
          pointer-events: auto;
          img {
            width: 36%;
            height: auto;
            pointer-events: none;
          }
          .item-name {
            height: auto;
            font-size: 1.2rem;
            line-height: 1.6rem;
            white-space: normal;
            word-break: break-word;
            overflow-wrap: break-word;
          }
          .sanjiao {
            display: none !important;
          }
        }
        .left-item1 {
          top: 12.8%;
          right: 14.6%;
          left: auto;
          bottom: auto;
        }
        .left-item2 {
          top: 57%;
          right: 2.7%;
          left: auto;
          bottom: auto;
        }
        .left-item3 {
          top: auto;
          right: 33%;
          left: auto;
          bottom: 7.1%;
        }
        .left-item4 {
          top: auto;
          right: auto;
          left: 12.5%;
          bottom: 16.9%;
        }
        .left-item5 {
          top: 42.8%;
          right: auto;
          left: 0;
          bottom: auto;
        }
        .left-item6 {
          top: 20.5%;
          right: auto;
          left: 8%;
          bottom: auto;
        }
        .left-item7 {
          top: 6.2%;
          right: auto;
          left: 28.6%;
          bottom: auto;
        }
      }
      .content-right {
        width: 100%;
        height: auto;
        margin: 0;
        .percentage {
          font-size: 4rem;
          line-height: 4.8rem;
          height: auto;
        }
        .right-name {
          font-size: 2.2rem;
          line-height: 3rem;
          height: auto;
        }
        .descs div {
          display: flex;
          align-items: flex-start;
          font-size: 1.5rem;
          line-height: 2.4rem;
          padding-left: 0;
          &::before {
            position: static;
            flex-shrink: 0;
            box-sizing: border-box;
            width: 1.2rem;
            height: 1.2rem;
            margin: 0.6rem 1rem 0 0;
            top: auto;
            left: auto;
          }
        }
      }
    }
  }
}
</style>
